import { Component, OnInit } from '@angular/core';
import { SlimLoadingBarService } from 'ng2-slim-loading-bar';
import { LoadingBarService } from './loading-bar.service';

@Component({
  selector: 'mc-loading-bar',
  template: `<ng2-slim-loading-bar  [height]="'4px'"></ng2-slim-loading-bar>`,
  styleUrls: []
})
export class LoadingBarComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/core/loading-bar/loading-bar.component.ts